const TypographyContainer = () => {
    return (
        <div className="typography-container">
            <div className="headings-typography">
                <h1>h1.Heading</h1>
                <h2>h2.Heading</h2>
                <h3>h3.Heading</h3>
                <h4>h4.Heading</h4>
                <h5>h5.Heading</h5>
                <h6>h6.Heading</h6>
            </div>
            <div className="section-typography">
                <div className="section-title">
                    section-title. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                    blanditiis tenetur
                </div>
                <div className="section-sub-title">
                    section-subtitle. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                    blanditiis tenetur
                </div>
            </div>
            <div className="body-typography">
                <div className="body-large">
                    body-large. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                    blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque
                    doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi
                    quidem quibusdam.
                </div>
                <div className="body-normal">
                    body. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis
                    tenetur unde suscipit, quam beatae rerum inventore consectetur, neque doloribus,
                    cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi quidem
                    quibusdam.
                </div>
                <div className="body-small">
                    body-small. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                    blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur, neque
                    doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum quasi
                    quidem quibusdam.
                </div>
            </div>
        </div>
    );
};

export default TypographyContainer;
